import { z } from 'zod';
export const DocumentFormatSchema = z.enum([
    'MONTHLY',
    'YEARLY_MONTH',
    'YEARLY_RUNNING',
    'LIFETIME',
]);
export const ResetRuleSchema = z.enum(['MONTHLY', 'YEARLY', 'NEVER']);
export const DocumentTypeSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    // 'JV' | 'PV' | 'RV' | ... — short prefix used in voucher numbers
    prefix: z.string().min(1).max(8),
    nameTh: z.string().min(1),
    format: DocumentFormatSchema,
    resetRule: ResetRuleSchema,
    padWidth: z.number().int().positive(),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateDocumentTypeSchema = DocumentTypeSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateDocumentTypeSchema = CreateDocumentTypeSchema.partial().omit({
    companyId: true,
});
// ============================================================
// VoucherBook (nested master under DocumentType)
// ============================================================
export const VoucherBookSchema = z.object({
    id: z.uuid(),
    docTypeId: z.uuid(),
    bookCode: z.string().min(1),
    nameTh: z.string().min(1),
    rangeStart: z.number().int().nonnegative(),
    rangeEnd: z.number().int().positive(),
    team: z.string().nullable().optional(),
    // 'auto-branch' | 'auto-dept' | 'manual' | 'hybrid' — kept as free-text in
    // Prisma; coordinator can tighten to z.enum at the API edge later.
    routingRule: z.string().nullable().optional(),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateVoucherBookSchema = VoucherBookSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateVoucherBookSchema = CreateVoucherBookSchema.partial().omit({
    docTypeId: true,
});
//# sourceMappingURL=document-type.js.map